import { define } from '../../define.js';
import { ProseEditor } from './prose-editor.js';
export * from './prose-editor.js';
define('prose-editor', ProseEditor);
